import React from 'react';
import styles from './SearchBlock.less';
import Sorting, { initialSortingOptions } from '../sorting/Sorting';
import { SearchGacInput } from '../searchgacinput/SearchGacInput';
import { useAppDispatch, useAppSelector } from '../../store/store';
import * as searchActions from '../../thunks/search';
import { onGacSuggestionSelected as _onGacSuggestionSelected, reportSearchSelection as _reportSearchSelection } from '../../thunks/gacSuggestion';
import { updateUrl as _updateUrl } from '../../thunks/updateUrl';
var SearchBlock = function SearchBlock() {
  var dispatch = useAppDispatch();
  var totalNumberOfAgents = useAppSelector(function (state) {
    return state.search.totalNumberOfAgents;
  });
  var apiEndPoint = useAppSelector(function (state) {
    return "".concat(state.config.API_ENDPOINT);
  });
  var selectedSuggestion = useAppSelector(function (state) {
    return state.gacOverAllInfo.selectedSuggestion;
  });
  var suggestionInputError = useAppSelector(function (state) {
    return state.gacOverAllInfo.suggestionInputError || false;
  });
  var initialSelectedSortingOption = useAppSelector(function (state) {
    return initialSortingOptions.find(function (sortingOption) {
      var _state$search$sorting, _state$search$sorting2;
      return sortingOption.sortBy === ((_state$search$sorting = state.search.sorting) === null || _state$search$sorting === void 0 ? void 0 : _state$search$sorting.sortBy) && sortingOption.sortOrder === ((_state$search$sorting2 = state.search.sorting) === null || _state$search$sorting2 === void 0 ? void 0 : _state$search$sorting2.order);
    }) || initialSortingOptions[0];
  }) || initialSortingOptions[0];
  return /*#__PURE__*/React.createElement("div", {
    className: styles.searchBlock
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex grid-align-center one-whole grid-justify-space-between "
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-flex grid-align-center  gutter-horizontal-l six-twelfth lap-eight-twelfth palm-one-whole margin-left-none"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-item searchBar ".concat(styles.searchBar)
  }, /*#__PURE__*/React.createElement(SearchGacInput, {
    apiEndPoint: apiEndPoint,
    selectedSuggestion: selectedSuggestion,
    suggestionInputError: suggestionInputError,
    onGacSuggestionSelected: function onGacSuggestionSelected(suggestion) {
      return dispatch(_onGacSuggestionSelected(suggestion));
    },
    searchAgents: function searchAgents() {
      return dispatch(searchActions.searchAgents());
    },
    updateUrl: function updateUrl() {
      return dispatch(_updateUrl());
    },
    reportSearchSelection: function reportSearchSelection() {
      return dispatch(_reportSearchSelection());
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "grid-item desk-hide lap-hide"
  }, totalNumberOfAgents && totalNumberOfAgents > 0 ? /*#__PURE__*/React.createElement(Sorting, {
    initialSelectedSortingOption: initialSelectedSortingOption,
    onSortOrderChange: function onSortOrderChange(sorting) {
      return dispatch(searchActions.onSortOrderChange(sorting));
    }
  }) : null)), /*#__PURE__*/React.createElement("div", {
    className: "grid-item palm-hide"
  }, totalNumberOfAgents && totalNumberOfAgents > 0 ? /*#__PURE__*/React.createElement(Sorting, {
    initialSelectedSortingOption: initialSelectedSortingOption,
    onSortOrderChange: function onSortOrderChange(sorting) {
      return dispatch(searchActions.onSortOrderChange(sorting));
    }
  }) : null)));
};
export default SearchBlock;